'use strict';

let einsteinItems = $('.js-einstein-item');

if(einsteinItems && einsteinItems.length > 0){
    einsteinItems.on('click', function (e) {
        var productTileID = $(this).attr('data-pid');
        var url = $(this).attr('data-trackactivity-url');
        var recoType = $(this).attr('data-reco-type');
        if (productTileID && recoType && url) {
            $.ajax({
                url: url +'?pid=' + productTileID + '&recoType=' + recoType,
                method: 'POST',
                success: function (response) {
                    console.log(response);
                },
                error: function (e) {}
            });
        }
    });
}